import React, { useContext } from 'react'
import FormattedMessage from '../../../helpers/FormattedMessage'
import LocalModalContext from '../LocalModalContext'
import closeIcon from '../../../assets/icons/icn-close.svg'

import styles from './Header.module.scss'

export interface HeaderProps {
  title: string
  staticContent?: boolean
}

export const Header: React.FC<HeaderProps> = ({ title, staticContent }) => {
  const { closeModal } = useContext(LocalModalContext)

  return (
    <div className={`${styles.Container} ${staticContent && styles.Static}`}>
      <div className={styles.Title}>
        <FormattedMessage id={title} />
      </div>
      <button className={styles.CloseBtn} onClick={closeModal}>
        <img src={closeIcon} alt={'close'}/>
      </button>
    </div>
  )
}
